import { Locale } from '@nemuru-eng/js-api-client';

import { LANGUAGES } from '../../../../../config/languages';

export const LANGUAGE_PARAMS = {
  [LANGUAGES.spanish]: {
    alpha_3: 'esp',
    label: 'Español',
    region: 'es',
  },
  [LANGUAGES.catalan]: {
    alpha_3: 'cat',
    label: 'Català',
    region: 'es',
  },
  [LANGUAGES.english]: {
    alpha_3: 'gbr',
    label: 'English',
    region: 'us',
  },
};

export const getLanguageByLocale = (locale: Locale) => {
  const language = new Intl.Locale(locale).language;

  if (language === 'es') return LANGUAGES.spanish;
  if (language === 'ca') return LANGUAGES.catalan;
  if (language === 'en') return LANGUAGES.english;

  return LANGUAGES.spanish;
};
